import login from '../assets/install-01-login.jpg'
import iosLogin from '../assets/install-ios-01-login.jpg'
import { box, type GuideStepContent } from './guideStep'

export const LOGIN_INTRO =
  'So melden Sie sich im Werkhof an — und was Sie tun, wenn Sie Ihr Passwort vergessen haben.'

export const LOGIN_STEPS: GuideStepContent[] = [
  {
    title: 'Mit E-Mail und Passwort anmelden',
    text: 'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein. Mit dem Auge-Symbol im Passwortfeld können Sie das Passwort anzeigen. Tippen Sie dann auf „Anmelden“.',
    image: login,
    imageAlt: 'Anmeldeseite mit den Feldern E-Mail und Passwort',
    focus: [box(105, 900, 815, 1295), box(105, 1336, 815, 1470)],
  },
  {
    title: 'Passwort vergessen?',
    text: 'Wenn Sie Ihr Passwort nicht mehr wissen, tippen Sie unter „Anmelden“ auf „Passwort vergessen?“.',
    image: iosLogin,
    imageAlt: 'Anmeldeseite mit dem Link „Passwort vergessen?“',
    focus: [box(300, 1390, 625, 1465)],
  },
]
